var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocmenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 28.5,
    cy: 14,
    r: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.3 33.9h-4.8c-1.6 0-2.9-1.3-2.9-2.9v-4.8c0-1.6 1.3-2.9 2.9-2.9h4.8c1.6 0 2.9 1.3 2.9 2.9V31c0 1.6-1.3 2.9-2.9 2.9zM16.3 19.1h-4.8c-1.6 0-2.9-1.3-2.9-2.9v-4.8c0-1.6 1.3-2.9 2.9-2.9h4.8c1.6 0 2.9 1.3 2.9 2.9v4.8c0 1.6-1.3 2.9-2.9 2.9zM31 33.9h-4.8c-1.6 0-2.9-1.3-2.9-2.9v-4.8c0-1.6 1.3-2.9 2.9-2.9H31c1.6 0 2.9 1.3 2.9 2.9V31c0 1.6-1.3 2.9-2.9 2.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M33.9 12.3v3.9c0 1.7-1.4 3-3 3h-4.5c-1.7 0-3-1.4-3-3v-4.5c0-1.7 1.4-3 3-3h3.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocmenu);
export default __webpack_public_path__ + "static/media/docmenu.1172fdaa1064fb9754aafde7afceac5b.svg";
export { ForwardRef as ReactComponent };